// Ecosystem session-inactivity policy, by module (route prefix).
//  - 'admin'       : auto-logout after 20 min inactivity (18-min warning).
//                    TFS Administration Hub, Tally, TFS Operations, Total Pay.
//  - 'operational' : NEVER auto-logout due to inactivity (manual logout only).
//                    CRM/REACH, ROUT, TEAM, Partners (planned), Field & Client portals.
//  - 'neutral'     : no inactivity enforcement (login, launcher, profile, public).
const ADMIN_PREFIXES = ['/tfs-admin', '/tfs-ops', '/payroll', '/contract-budgets', '/tally', '/admin'];
const OPERATIONAL_PREFIXES = ['/rout', '/rout-admin', '/operations', '/team', '/team-hub', '/partners', '/crm', '/reach', '/client', '/field'];

const matches = (p, list) => list.some((x) => p === x || p.startsWith(x + '/'));

export const modulePolicyFor = (pathname = '') => {
  const p = (pathname || '').toLowerCase();
  if (matches(p, ADMIN_PREFIXES)) return 'admin';
  if (matches(p, OPERATIONAL_PREFIXES)) return 'operational';
  return 'neutral';
};

export const isAdminModule = (pathname) => modulePolicyFor(pathname) === 'admin';
